/**
 * Header cart count badge.
 *
 * The theme's own cart drawer used to keep [data-cart-count] in sync, but it is
 * disabled on this store - the Kaching Cart app owns the cart. Kaching updates
 * its own UI but not the theme's badge, so without this the number only
 * refreshed on a full page load and could show a stale count.
 *
 * Kaching patches both fetch and XMLHttpRequest, so rather than hook into it we
 * observe any request to a cart-mutating endpoint and re-read /cart.js after it
 * settles. The wrappers below only observe - they never alter arguments,
 * responses, or errors.
 */
(function () {
  'use strict';

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var DEBOUNCE_MS = 250;

  // Captured before we wrap anything, so refreshing can never re-enter our own
  // interceptor and loop.
  var passthroughFetch = window.fetch.bind(window);
  var timer = null;

  function render(count) {
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      if (count > 0) {
        badges[i].removeAttribute('hidden');
      } else {
        badges[i].setAttribute('hidden', '');
      }
    }
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      passthroughFetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (cart && typeof cart.item_count === 'number') render(cart.item_count);
        })
        .catch(function () {
          /* A failed badge refresh must never surface to the shopper. */
        });
    }, DEBOUNCE_MS);
  }

  var innerFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = innerFetch.apply(this, arguments);
    if (CART_MUTATION.test(url) && result && typeof result.then === 'function') {
      result.then(refresh, function () {});
    }
    return result;
  };

  var innerOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_MUTATION.test(String(url))) {
      this.addEventListener('loadend', refresh);
    }
    return innerOpen.apply(this, arguments);
  };

  // Safety net: quantity steppers and remove buttons inside the app's drawer may
  // reach the cart by a route we don't match above.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (target.closest('[class*="kaching-cart"], form[action*="/cart"]')) refresh();
    },
    true
  );

  // Restoring from the back/forward cache replays a stale DOM.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });
})();
